import React from "react";
import classNames from "classnames";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { ChatBubbleProps } from "../..";
import styles from "./chat-text.module.scss";

type HasMedia = { hasMedia: boolean };

const ChatText = ({
  text,
  messageType,
  timestamp,
  hasMedia,
}: ChatBubbleProps & HasMedia) => {
  const hasText = !!text;

  return (
    <div
      className={classNames(styles.texts, {
        [styles.zeroHeight]: !hasText && hasMedia,
      })}
    >
      {hasText && (
        <Paragraph className={styles.text} size="small" weight="book">
          {text}
        </Paragraph>
      )}
      <Paragraph
        className={classNames(styles.timestamp, {
          [styles.textPadding]: hasText,
        })}
        data-message-type={messageType}
        size="tiny"
        weight="book"
      >
        {timestamp}
      </Paragraph>
    </div>
  );
};

export default ChatText;
